import { render, staticRenderFns } from "./CompactChart.vue?vue&type=template&id=1dbc9144&"
import script from "./CompactChart.vue?vue&type=script&lang=js&"
export * from "./CompactChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports